module.exports = __webpack_public_path__ + "static/img/share_ic4.6d9bcbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedHome/share_ic4.png
// module id = HNZS
// module chunks = 1